import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import {
	type LWApiPublicNetworkLoadBalancerPossibleNodesParamsI,
	type LWApiPublicNetworkLoadBalancerPossibleNodesResultI,
} from '@liquidweb-dev/club-sauce/public/network/loadbalancer/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';

export const NETWORK_LOADBALANCER_POSSIBLE_NODES_QUERY_KEY =
	'/network/loadbalancer/possibleNodes';

const useLoadBalancerPossibleNodes = (
	params: LWApiPublicNetworkLoadBalancerPossibleNodesParamsI,
	options?: UseQueryOptions<
		LWApiPublicNetworkLoadBalancerPossibleNodesResultI,
		ApiErrorI
	>,
) =>
	useQuery({
		queryKey: [NETWORK_LOADBALANCER_POSSIBLE_NODES_QUERY_KEY, params],
		queryFn: () => api.network.loadbalancer.apiRaw.possibleNodes(params),
		...options,
	});

export default useLoadBalancerPossibleNodes;
